module.exports = __webpack_public_path__ + "static/media/holiday_help_map.d420232a.svg";